import actions from './actions';

const addNotification = key => ({
  type: actions.ADD_NOTIFICATION,
  payload: {key}
});
const clearNotification = key => ({
  type: actions.CLEAR_NOTIFICATION,
  payload: {key}
});

export default {
  addNotification,
  clearNotification
};
